import { render, staticRenderFns } from "./MyClasses.vue?vue&type=template&id=2b13982d&scoped=true"
import script from "./MyClasses.vue?vue&type=script&lang=js"
export * from "./MyClasses.vue?vue&type=script&lang=js"
import style0 from "./MyClasses.vue?vue&type=style&index=0&id=2b13982d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13982d",
  null
  
)

export default component.exports